import { GetEvaluationFormTemplatesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useGetEvaluationFormTemplates = () => {
  const { loading, data } = useQuery(GetEvaluationFormTemplatesDocument, {})

  return {
    loading,
    evaluationFormTemplates: data?.ats.evaluationFormsConnection.nodes || [],
  }
}
